/**
* this is the simple loader component composed by few horizontalbars
*
* Created by Min on 17/08/18
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

// style import
import './style.scss'

export default class SimpleLoader extends Component {

    render() {

        const { show, title, darkMode, num } = this.props

        return (
            show &&
            <div className={cx('simple-loader', {'simple-loader--dark-mode': darkMode})}>
                {title && <div className="simple-loader__title">{title}</div>}
                {[...new Array(num)].map((d, index) => (
                    <div key={index} className="simple-loader__section">
                        <div className="animated-bg animated-bg--short"></div>
                        <div className="animated-bg animated-bg--long"></div>
                        <div className="animated-bg animated-bg--long"></div>
                        <div className="animated-bg animated-bg--long"></div>
                    </div>
                ))}
            </div>
        )
    }
}

// define the prop types
SimpleLoader.propTypes = {
    num: PropTypes.number.isRequired,
    show: PropTypes.bool.isRequired,
    title: PropTypes.string,
    darkMode: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./src/components/SimpleLoader/index.js